
export const MedialFileEN = {
  "MediaFileTitle": {
    "Attach": "Attach",
    "AttachmentType": "Attachment Type",
    "ListAttach": "List of attached files",
    "Upload": "Upload",
    "Notify" : "Notify",
    "AttachedFile" : "Attached File",
    "Operations" : "Operations",
    "FileName" : "File Name",
    "TypeFile" : "Type file"
  },
  "NotificationMediaFile": {
    "delete" : "Delete File successfully... ",
    "question" : "Are you sure you want to delete this file?"
  },
  "valueMediaFile": {
    "HD" : "Contract",
    "TLK" : "Other documents",
    "LD" : " Reason ",
    "VB-CC" : "Diplomas and certificates ",
    "LL" : "Profile"
  }
}
